// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cb-input-field {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: var(--cb-container-wide-width);
  align-self: center;
  margin-bottom: 0.75rem;
}

.cb-input-label {
  display: flex;
  flex-direction: row;
  gap: 0.1rem;
  justify-content: space-between;
  align-items: center;
  width: var(--cb-container-full-width);
}

.cb-input-label-text {
  margin-top: 0.4rem;
  padding-left: 0.3rem;
  align-self: flex-start;
}

.cb-input-label-link {
  margin-top: 0.4rem;
  padding-right: 0.3rem;
  align-self: flex-end;
}

.cb-input {
  margin-top: 0.3rem;
  flex-grow: 1;
  border-radius: var(--cb-border-radius-sm);
  border: 1px solid var(--cb-border-color);
  height: var(--cb-input-field-height);
  padding-left: 0.6rem;
  justify-content: center;
  font-family: var(--cb-secondary-font);
  font-weight: var(--cb-font-weight-normal);
  background-color: var(--cb-white);
  color: var(--cb-input-text-color);
  box-sizing: border-box;
}

.cb-input:focus {
  outline: none;
  border: 1px solid var(--cb-primary-color);
}

.cb-input:disabled {
  background-color: var(--cb-input-disabled-color);
}

.cb-input-error {
  border: 1px solid var(--cb-error-text-color);
}

.cb-phone-input-field {
  display: flex;
  flex-direction: row;
  position: relative;
  margin-top: 0.3rem;
  flex-grow: 1;
  font-family: var(--cb-secondary-font);
  font-weight: var(--cb-font-weight-normal);
  background-color: var(--cb-white);
  color: var(--cb-text-primary-color);
  border-radius: var(--cb-border-radius-sm);
  border: 1px solid var(--cb-border-color);
  height: var(--cb-input-field-height);
  align-items: center;
}

.cb-phone-input-field-disabled {
  background-color: var(--cb-input-disabled-color);
}

.cb-phone-input-field:focus-within {
  outline: none;
  border: 1px solid var(--cb-primary-color);
}

.cb-phone-input-field.cb-input-error {
  border: 1px solid var(--cb-error-text-color);
}

.cb-phone-input-field-button {
  flex: 1;
  display: flex;
  flex-direction: row;
  color: var(--cb-text-primary-color);
  background-color: var(--cb-box-color);
  cursor: pointer;
  gap: 0.25rem;
  align-items: center;
  border: 0px;
  padding-left: 0.8rem;
  height: var(--cb-container-full-width);
  border-top-left-radius: var(--cb-border-radius-sm);
  border-bottom-left-radius: var(--cb-border-radius-sm);
}

.cb-phone-input-field-button svg {
  width: 20px;
}

.cb-phone-input-field-button img {
  width: 1rem;
}

.cb-phone-input-field-button-disabled {
  background-color: var(--cb-input-disabled-color);
  cursor: not-allowed;
}

.cb-phone-input-field-selection {
  position: absolute;
  width: var(--cb-container-full-width);
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 1;
  background-color: var(--cb-box-color);
  top: calc(var(--cb-input-field-height) * 1.1);
  height: 250px;
  overflow-y: auto;
}

.cb-phone-input-field-selection svg {
  width: 20px;
}

.cb-phone-input-field-selection-item {
  padding: 0.75rem 1.5rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  border-bottom: 1px solid var(--cb-border-color);
}

.cb-phone-input-field-selection-item-selected {
  cursor: none;
  background-color: var(--cb-box-color-hover);
  color: var(--cb-primary-color);
}

.cb-phone-input-field-selection-item:hover {
  background-color: var(--cb-box-color-hover);
}

.cb-phone-input-field-input {
  flex: 4;
  border: 0px;
  height: calc(var(--cb-input-field-height) - 0.2rem);
  width: var(--cb-container-full-width);
  padding: 0 0.4rem;
  color: var(--cb-input-text-color);
  background-color: var(--cb-white);
  font-family: var(--cb-secondary-font);
  border-top-right-radius: var(--cb-border-radius-sm);
  border-bottom-right-radius: var(--cb-border-radius-sm);
}

.cb-phone-input-field-input:focus {
  outline: none;
}

.cb-phone-input-field-input:disabled {
  background-color: var(--cb-input-disabled-color);
}

.cb-phone-input-field-search {
  background-color: var(--cb-white);
  font-family: var(--cb-secondary-font);
  color: var(--cb-input-text-color);
  height: var(--cb-input-field-height);
  font-weight: var(--cb-font-weight-normal);
  border: none;
  margin-bottom: 0.5rem;
  width: 98%;
}

.cb-phone-input-field-search:focus {
  outline: none;
}

.cb-input:-webkit-autofill,
.cb-input:-webkit-autofill:hover,
.cb-input:-webkit-autofill:focus,
.cb-input:-webkit-autofill:active,
.cb-phone-input-field-input:-webkit-autofill,
.cb-phone-input-field-input:-webkit-autofill:hover,
.cb-phone-input-field-input:-webkit-autofill:focus,
.cb-phone-input-field-input:-webkit-autofill:active {
  -webkit-box-shadow: 0 0 0 30px var(--cb-white) inset;
  -webkit-text-fill-color: var(--cb-input-text-color);
}

.cb-error-message {
  display: flex;
  font-family: var(--cb-secondary-font);
  font-size: var(--cb-error-font-size);
  color: var(--cb-error-text-color);
  margin-top: 0.2rem;
  align-items: center;
  padding-left: 0.25rem;
  font-weight: var(--cb-font-weight-normal);
}

.cb-error-message-icon-container {
  flex: 1;
  height: 1.3rem;
}

.cb-error-message-icon {
  width: 1.2rem;
}

.cb-error-message-text {
  flex: 11;
  line-height: 1.2;
}

.cb-checkbox-input-field {
  display: block;
  position: relative;
  padding-left: 1.5rem;
  margin: 1.25rem auto 0.75rem;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* Hide the browser's default checkbox */
.cb-checkbox-input-field input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

.cb-checkbox-input {
  position: absolute;
  top: 0;
  left: 0;
  height: 18px;
  width: 18px;
  background-color: var(--cb-white);
  border: 1px solid var(--cb-dark);
  border-radius: 0.2rem;
}

.cb-checkbox-input-field:hover input ~ .cb-checkbox-input {
  background-color: var(--cb-box-color-hover);
}

.cb-checkbox-input-field input:checked ~ .cb-checkbox-input {
  background-color: var(--cb-primary-color);
}

/* Move the :after pseudo-element to .cb-checkbox-input */
.cb-checkbox-input::after {
  content: '';
  position: absolute;
  display: none;
}

.cb-checkbox-input-field input:checked ~ .cb-checkbox-input::after {
  display: block;
  left: 5px;
  top: 2px;
  width: 5px;
  height: 10px;
  border: solid var(--cb-button-text-primary-color);
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}
`, "",{"version":3,"sources":["webpack://./src/styles/inputs.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,qCAAqC;EACrC,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,8BAA8B;EAC9B,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,yCAAyC;EACzC,wCAAwC;EACxC,oCAAoC;EACpC,oBAAoB;EACpB,uBAAuB;EACvB,qCAAqC;EACrC,yCAAyC;EACzC,iCAAiC;EACjC,iCAAiC;EACjC,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,yCAAyC;AAC3C;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,qCAAqC;EACrC,yCAAyC;EACzC,iCAAiC;EACjC,mCAAmC;EACnC,yCAAyC;EACzC,wCAAwC;EACxC,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,yCAAyC;AAC3C;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,mCAAmC;EACnC,qCAAqC;EACrC,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,sCAAsC;EACtC,kDAAkD;EAClD,qDAAqD;AACvD;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gDAAgD;EAChD,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,+CAA+C;EAC/C,UAAU;EACV,qCAAqC;EACrC,6CAA6C;EAC7C,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,+CAA+C;AACjD;;AAEA;EACE,YAAY;EACZ,2CAA2C;EAC3C,8BAA8B;AAChC;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,OAAO;EACP,WAAW;EACX,mDAAmD;EACnD,qCAAqC;EACrC,iBAAiB;EACjB,iCAAiC;EACjC,iCAAiC;EACjC,qCAAqC;EACrC,mDAAmD;EACnD,sDAAsD;AACxD;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,iCAAiC;EACjC,qCAAqC;EACrC,iCAAiC;EACjC,oCAAoC;EACpC,yCAAyC;EACzC,YAAY;EACZ,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;;;;;;;;EAQE,oDAAoD;EACpD,mDAAmD;AACrD;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,oCAAoC;EACpC,iCAAiC;EACjC,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,OAAO;EACP,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,oBAAoB;EACpB,4BAA4B;EAC5B,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA,wCAAwC;AACxC;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,SAAS;EACT,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,YAAY;EACZ,WAAW;EACX,iCAAiC;EACjC,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA,yDAAyD;AACzD;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,SAAS;EACT,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,iDAAiD;EACjD,yBAAyB;EACzB,gCAAgC;EAChC,4BAA4B;EAC5B,wBAAwB;AAC1B","sourcesContent":[".cb-input-field {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  width: var(--cb-container-wide-width);\n  align-self: center;\n  margin-bottom: 0.75rem;\n}\n\n.cb-input-label {\n  display: flex;\n  flex-direction: row;\n  gap: 0.1rem;\n  justify-content: space-between;\n  align-items: center;\n  width: var(--cb-container-full-width);\n}\n\n.cb-input-label-text {\n  margin-top: 0.4rem;\n  padding-left: 0.3rem;\n  align-self: flex-start;\n}\n\n.cb-input-label-link {\n  margin-top: 0.4rem;\n  padding-right: 0.3rem;\n  align-self: flex-end;\n}\n\n.cb-input {\n  margin-top: 0.3rem;\n  flex-grow: 1;\n  border-radius: var(--cb-border-radius-sm);\n  border: 1px solid var(--cb-border-color);\n  height: var(--cb-input-field-height);\n  padding-left: 0.6rem;\n  justify-content: center;\n  font-family: var(--cb-secondary-font);\n  font-weight: var(--cb-font-weight-normal);\n  background-color: var(--cb-white);\n  color: var(--cb-input-text-color);\n  box-sizing: border-box;\n}\n\n.cb-input:focus {\n  outline: none;\n  border: 1px solid var(--cb-primary-color);\n}\n\n.cb-input:disabled {\n  background-color: var(--cb-input-disabled-color);\n}\n\n.cb-input-error {\n  border: 1px solid var(--cb-error-text-color);\n}\n\n.cb-phone-input-field {\n  display: flex;\n  flex-direction: row;\n  position: relative;\n  margin-top: 0.3rem;\n  flex-grow: 1;\n  font-family: var(--cb-secondary-font);\n  font-weight: var(--cb-font-weight-normal);\n  background-color: var(--cb-white);\n  color: var(--cb-text-primary-color);\n  border-radius: var(--cb-border-radius-sm);\n  border: 1px solid var(--cb-border-color);\n  height: var(--cb-input-field-height);\n  align-items: center;\n}\n\n.cb-phone-input-field-disabled {\n  background-color: var(--cb-input-disabled-color);\n}\n\n.cb-phone-input-field:focus-within {\n  outline: none;\n  border: 1px solid var(--cb-primary-color);\n}\n\n.cb-phone-input-field.cb-input-error {\n  border: 1px solid var(--cb-error-text-color);\n}\n\n.cb-phone-input-field-button {\n  flex: 1;\n  display: flex;\n  flex-direction: row;\n  color: var(--cb-text-primary-color);\n  background-color: var(--cb-box-color);\n  cursor: pointer;\n  gap: 0.25rem;\n  align-items: center;\n  border: 0px;\n  padding-left: 0.8rem;\n  height: var(--cb-container-full-width);\n  border-top-left-radius: var(--cb-border-radius-sm);\n  border-bottom-left-radius: var(--cb-border-radius-sm);\n}\n\n.cb-phone-input-field-button svg {\n  width: 20px;\n}\n\n.cb-phone-input-field-button img {\n  width: 1rem;\n}\n\n.cb-phone-input-field-button-disabled {\n  background-color: var(--cb-input-disabled-color);\n  cursor: not-allowed;\n}\n\n.cb-phone-input-field-selection {\n  position: absolute;\n  width: var(--cb-container-full-width);\n  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);\n  z-index: 1;\n  background-color: var(--cb-box-color);\n  top: calc(var(--cb-input-field-height) * 1.1);\n  height: 250px;\n  overflow-y: auto;\n}\n\n.cb-phone-input-field-selection svg {\n  width: 20px;\n}\n\n.cb-phone-input-field-selection-item {\n  padding: 0.75rem 1.5rem;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  border-bottom: 1px solid var(--cb-border-color);\n}\n\n.cb-phone-input-field-selection-item-selected {\n  cursor: none;\n  background-color: var(--cb-box-color-hover);\n  color: var(--cb-primary-color);\n}\n\n.cb-phone-input-field-selection-item:hover {\n  background-color: var(--cb-box-color-hover);\n}\n\n.cb-phone-input-field-input {\n  flex: 4;\n  border: 0px;\n  height: calc(var(--cb-input-field-height) - 0.2rem);\n  width: var(--cb-container-full-width);\n  padding: 0 0.4rem;\n  color: var(--cb-input-text-color);\n  background-color: var(--cb-white);\n  font-family: var(--cb-secondary-font);\n  border-top-right-radius: var(--cb-border-radius-sm);\n  border-bottom-right-radius: var(--cb-border-radius-sm);\n}\n\n.cb-phone-input-field-input:focus {\n  outline: none;\n}\n\n.cb-phone-input-field-input:disabled {\n  background-color: var(--cb-input-disabled-color);\n}\n\n.cb-phone-input-field-search {\n  background-color: var(--cb-white);\n  font-family: var(--cb-secondary-font);\n  color: var(--cb-input-text-color);\n  height: var(--cb-input-field-height);\n  font-weight: var(--cb-font-weight-normal);\n  border: none;\n  margin-bottom: 0.5rem;\n  width: 98%;\n}\n\n.cb-phone-input-field-search:focus {\n  outline: none;\n}\n\n.cb-input:-webkit-autofill,\n.cb-input:-webkit-autofill:hover,\n.cb-input:-webkit-autofill:focus,\n.cb-input:-webkit-autofill:active,\n.cb-phone-input-field-input:-webkit-autofill,\n.cb-phone-input-field-input:-webkit-autofill:hover,\n.cb-phone-input-field-input:-webkit-autofill:focus,\n.cb-phone-input-field-input:-webkit-autofill:active {\n  -webkit-box-shadow: 0 0 0 30px var(--cb-white) inset;\n  -webkit-text-fill-color: var(--cb-input-text-color);\n}\n\n.cb-error-message {\n  display: flex;\n  font-family: var(--cb-secondary-font);\n  font-size: var(--cb-error-font-size);\n  color: var(--cb-error-text-color);\n  margin-top: 0.2rem;\n  align-items: center;\n  padding-left: 0.25rem;\n  font-weight: var(--cb-font-weight-normal);\n}\n\n.cb-error-message-icon-container {\n  flex: 1;\n  height: 1.3rem;\n}\n\n.cb-error-message-icon {\n  width: 1.2rem;\n}\n\n.cb-error-message-text {\n  flex: 11;\n  line-height: 1.2;\n}\n\n.cb-checkbox-input-field {\n  display: block;\n  position: relative;\n  padding-left: 1.5rem;\n  margin: 1.25rem auto 0.75rem;\n  cursor: pointer;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n\n/* Hide the browser's default checkbox */\n.cb-checkbox-input-field input {\n  position: absolute;\n  opacity: 0;\n  cursor: pointer;\n  height: 0;\n  width: 0;\n}\n\n.cb-checkbox-input {\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 18px;\n  width: 18px;\n  background-color: var(--cb-white);\n  border: 1px solid var(--cb-dark);\n  border-radius: 0.2rem;\n}\n\n.cb-checkbox-input-field:hover input ~ .cb-checkbox-input {\n  background-color: var(--cb-box-color-hover);\n}\n\n.cb-checkbox-input-field input:checked ~ .cb-checkbox-input {\n  background-color: var(--cb-primary-color);\n}\n\n/* Move the :after pseudo-element to .cb-checkbox-input */\n.cb-checkbox-input::after {\n  content: '';\n  position: absolute;\n  display: none;\n}\n\n.cb-checkbox-input-field input:checked ~ .cb-checkbox-input::after {\n  display: block;\n  left: 5px;\n  top: 2px;\n  width: 5px;\n  height: 10px;\n  border: solid var(--cb-button-text-primary-color);\n  border-width: 0 3px 3px 0;\n  -webkit-transform: rotate(45deg);\n  -ms-transform: rotate(45deg);\n  transform: rotate(45deg);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
